import React, { useState } from 'react';
import { verificationAPI } from '../../services/api';
import Navbar from '../../components/Navbar';
import './Verify.css';

const VerifyPAN = () => {
  const [pan, setPan] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setResult(null);

    try {
      const response = await verificationAPI.verifyPAN(pan.toUpperCase());
      setResult(response);
    } catch (err) {
      setError(err.response?.data?.message || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verify-page">
      <Navbar />
      
      <div className="verify-container">
        <div className="verify-card">
          <h2>🆔 PAN Verification</h2>
          <p className="verify-description">
            Verify Permanent Account Number (PAN) details
          </p>

          <form onSubmit={handleSubmit} className="verify-form">
            <div className="form-group">
              <label>PAN Number</label>
              <input
                type="text"
                value={pan}
                onChange={(e) => setPan(e.target.value)}
                placeholder="AAAAA9999A"
                maxLength="10"
                required
                pattern="[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"
                title="PAN format: AAAAA9999A"
              />
              <small>Format: 5 letters, 4 digits, 1 letter (e.g., ABCDE1234F)</small>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="verify-button" disabled={loading}>
              {loading ? 'Verifying...' : 'Verify PAN'}
            </button>
          </form>

          {result && (
            <div className="result-card">
              <h3>Verification Result</h3>
              <div className={`result-status ${result.success ? 'success' : 'failed'}`}>
                {result.success ? '✓ Verification Successful' : '✗ Verification Failed'}
              </div>
              
              {result.data && (
                <div className="result-details">
                  <table className="result-table">
                    <tbody>
                      <tr>
                        <td><strong>Registered Name</strong></td>
                        <td>
                          {result.data.registered_name || 
                           result.data['Name Registered'] || 
                           result.data.name_provided || 
                           '–'}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>PAN Type</strong></td>
                        <td>
                          {result.data.type || 
                           result.data.pan_type || 
                           result.data['PAN Type'] || 
                           '–'}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>PAN Ref. ID</strong></td>
                        <td>
                          {result.data.reference_id || 
                           result.data.ref_id || 
                           '–'}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Valid</strong></td>
                        <td>
                          {result.data.valid !== undefined 
                            ? (result.data.valid ? 'Yes' : 'No')
                            : (result.data.Valid !== undefined 
                                ? (result.data.Valid === 'Yes' ? 'Yes' : 'No')
                                : '–')}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Message</strong></td>
                        <td>
                          {result.message || 
                           result.data.message || 
                           result.data.Message || 
                           'PAN verified successfully'}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Name Match Result</strong></td>
                        <td>
                          {result.data.name_match_result || 
                           result.data['Name Match Score'] || 
                           '–'}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Aadhaar Seeding Status</strong></td>
                        <td>
                          {result.data.aadhaar_seeding_status || 
                           result.data.aadhaarSeedingStatus || 
                           result.data['Aadhaar Seeding Status'] || 
                           '–'}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Last Updated At</strong></td>
                        <td>{result.data.last_updated_at || result.data['Last updated at'] || '–'}</td>
                      </tr>
                      <tr>
                        <td><strong>Name on PAN Card</strong></td>
                        <td>
                          {result.data.name_on_card || 
                           result.data['Name Pan Card'] || 
                           result.data.registered_name || 
                           result.data['Name Registered'] ||
                           result.data.name_provided || 
                           '–'}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>PAN Status</strong></td>
                        <td>
                          {result.data.pan_status || 
                           result.data['Pan Status'] || 
                           (result.data.valid ? 'VALID' : 'INVALID')}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Aadhaar Seeding Status Description</strong></td>
                        <td>
                          {result.data.aadhaar_seeding_status_desc || 
                           result.data.aadhaarSeedingStatusDesc || 
                           result.data['Aadhaar Seeding Status Description'] || 
                           '–'}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyPAN;
